// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1Su32","header":"Messages_header__38G6H"};